export const TransientAccessCredEventNames = {
  NEW_CRED_SAVED: 'NEW_CRED_SAVED',
  CRED_CLEARED: 'CRED_CLEARED',
  OPEN_CRED_DIALOG: 'OPEN_CRED_DIALOG',
  CRED_FORM_ENTRY_CANCELLED: 'CRED_FORM_ENTRY_CANCELLED',
  TOGGLE_CRED_STEPS: 'TOGGLE_CRED_STEPS'
};



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/prevent_transient_access/constants/transient_access_cred_constants.ts